import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import Seo from "../components/Seo";
import Brand from "../components/Brand";

export default function Login() {
  const { login, loading } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });

  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      await login(form.email, form.password);
      toast.success("Welcome back!");
      nav("/app");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    }
  };

  return (
    <div className="min-h-screen bg-mesh grid place-items-center p-6">
      <Seo title="Log In | WriterSpark" description="Sign in to your WriterSpark account to continue your writing practice." path="/login" noindex />
      <div className="w-full max-w-md tactile-card p-8 sm:p-10">
        <div className="mb-8"><Brand to="/" tone="light" size="lg" /></div>
        <h1 className="text-3xl font-bold mb-2" style={{fontFamily:'Outfit'}}>Welcome back</h1>
        <p className="text-slate-600 mb-8">Sign in to continue your writing practice.</p>
        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="text-xs uppercase font-bold tracking-widest text-slate-500">Email</label>
            <input data-testid="login-email" type="email" required value={form.email}
              onChange={(e)=>setForm({...form, email:e.target.value})}
              className="mt-1 w-full rounded-2xl border-2 border-slate-200 bg-slate-50 focus:bg-white focus:border-indigo-400 px-4 py-3 text-base outline-none transition" />
          </div>
          <div>
            <label className="text-xs uppercase font-bold tracking-widest text-slate-500">Password</label>
            <input data-testid="login-password" type="password" required value={form.password}
              onChange={(e)=>setForm({...form, password:e.target.value})}
              className="mt-1 w-full rounded-2xl border-2 border-slate-200 bg-slate-50 focus:bg-white focus:border-indigo-400 px-4 py-3 text-base outline-none transition" />
          </div>
          <button data-testid="login-submit" disabled={loading} type="submit" className="w-full bg-indigo-600 hover:bg-indigo-500 text-white font-bold rounded-full py-3.5 tactile-shadow disabled:opacity-60">
            {loading ? "Signing in..." : "Sign in"}
          </button>
        </form>
        <p className="text-center text-sm text-slate-600 mt-6">
          New here? <Link to="/register" data-testid="link-register" className="text-indigo-700 font-bold">Create an account</Link>
        </p>
      </div>
    </div>
  );
}
